import React from "react";
import { FiCpu, FiUser, FiExternalLink } from "react-icons/fi";

const agents = [
  {
    id: 1,
    name: "SDR Support Agent",
    owner: "Patrick Van Bueren",
    description: "Sales Development Representative support and assistance",
    link: "https://m365.cloud.microsoft:443/chat/?titleId=T_47f031b2-761a-be19-265a-841e34814c62&source=embedded-builder", // Update with actual link
  },
  {
    id: 2,
    name: "Complete Commerce Agent",
    owner: "David Hore",
    description: "Complete Commerce Product Information",
    link: "https://m365.cloud.microsoft:443/chat/?titleId=T_59e8046a-5f26-f238-cd62-97a9bc905bf2&source=embedded-builder", // Update with actual link
  },
  {
    id: 3,
    name: "SCQA Agent",
    owner: "Gabriela Church",
    description: "An agent that helps Sales Managers create SCQAs for sales opportunities, ensuring each is tailored to client's needs and follows the SCQA principles.",
    link: "https://m365.cloud.microsoft:443/chat/?titleId=T_a1cccabd-9dac-41d3-a2cf-8a90b9807cb7&source=embedded-builder", // Update with actual link
  },
  {
    id: 4,
    name: "Cover Letter & Executive Summary Assistant",
    owner: "Gabriela Church",
    description: "Crafts executive summaries and cover letters for RFx responses and proposals, following a standard framework including Introduction, Our Understanding, Our Response, How TNS Meets Your Requirements and How TNS Differentiates.",
    link: "https://m365.cloud.microsoft/chat/?titleId=T_fca5182c-0445-e3a9-71a0-3ebb9320d1e0&source=embedded-builder",
  },
];

export default function Agents() {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center bg-indigo-100 text-indigo-800 px-4 py-2 rounded-full text-sm font-medium mb-4">
            <FiCpu className="w-4 h-4 mr-2" />
            Copilot AI Agents
          </div>
          <h1 className="text-4xl font-bold text-gray-900">
            Agents
          </h1>
          <p className="mt-3 text-lg text-gray-600">
            Use TNSPay's official collection of specialized Copilot Agents
          </p>
        </div>

        {/* Agents Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {agents.map((agent) => (
            <a
              key={agent.id}
              href={agent.link}
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-white border border-gray-200 rounded-2xl p-6 hover:border-indigo-300 hover:shadow-xl transition-all duration-300"
            >
              {/* Icon */}
              <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <FiCpu className="w-6 h-6 text-white" />
              </div>

              {/* Content */}
              <div className="space-y-2">
                <div className="flex items-center justify-between">
                  <h3 className="text-lg font-semibold text-gray-900 group-hover:text-indigo-600 transition-colors">
                    {agent.name}
                  </h3>
                  <FiExternalLink className="w-4 h-4 text-gray-400 group-hover:text-indigo-500 transition-colors" />
                </div>
                
                <p className="text-sm text-gray-600">
                  {agent.description}
                </p>

                {/* Owner */}
                <div className="flex items-center pt-3 border-t border-gray-100 mt-3">
                  <FiUser className="w-4 h-4 text-gray-400 mr-2" />
                  <span className="text-sm text-gray-500">
                    {agent.owner}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
